import(/* webpackMode: "eager" */ "/var/www/zamzam/web/src/app/[locale]/(server-styles-loader)/(auth)/reset-password/page.tsx");
